<template>
  <div v-if="isOpen" class="overlay" @click="close">
    <div class="drawer" @click.stop>
      
      <div class="handle"></div>

      <h3 class="title">
        Пользователь отправил вам запрос
      </h3>

      <div class="buttons">

        <div class="action">
          <button class="circle accept" @click="accept">
            <svg viewBox="0 0 24 24">
              <path d="M9 16.2l-3.5-3.5L4 14.2 9 19 20 8l-1.5-1.5z"/>
            </svg>
          </button>
          <span>Принять</span>
        </div>

        <div class="action">
          <button class="circle decline" @click="decline">
            <svg viewBox="0 0 24 24">
              <path d="M18 6L6 18M6 6l12 12" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
          <span>Отклонить</span>
        </div>

      </div>

    </div>
  </div>
</template>

<script setup>
defineProps({
  isOpen: Boolean
})

const emit = defineEmits(["close", "accept", "decline"])

const close = () => emit("close")
const accept = () => emit("accept")
const decline = () => emit("decline")
</script>

<style scoped>

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.25s ease forwards;
}

.drawer {
  width: 100%;
  max-width: 500px;
  background: #ffffff;
  padding: 28px 24px 40px;
  box-shadow: 0 -15px 40px rgba(0,0,0,0.15);
  animation: slideUp 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  margin-bottom: 40px;

  border-top-left-radius: 28px;
  border-top-right-radius: 28px;

  border-bottom-left-radius: 28px;
  border-bottom-right-radius: 28px;
}

[data-theme="dark"] .drawer {
  background: #1f1f1f;
  color: white;
}

.handle {
  width: 50px;
  height: 5px;
  background: #dcdcdc;
  border-radius: 3px;
  margin: 0 auto 28px;
}

.title {
  text-align: center;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 18px;
  margin-bottom: 36px;
  line-height: 1.4;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 60px;
}

.action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  font-family: "Eastman-Medium", sans-serif;
  font-size: 13px;
}

/* 🔵 🔴 Circle buttons */

.circle {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

.circle svg {
  width: 30px;
  height: 30px;
  fill: white;
  stroke: white;
}

/* Accept */

.accept {
  background: linear-gradient(135deg, #2A7AFE, #1B5FD1);
}

.accept:hover {
  transform: translateY(-5px) scale(1.08);
  box-shadow: 0 15px 35px rgba(42,122,254,0.5);
}

/* Decline */

.decline {
  background: linear-gradient(135deg, #ff4d4d, #d93636);
}

.decline:hover {
  transform: translateY(-5px) scale(1.08);
  box-shadow: 0 15px 35px rgba(255,77,77,0.5);
}

/* Press effect */

.circle:active {
  transform: scale(0.92);
}

/* Animations */

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0.8;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from { opacity: 0 }
  to { opacity: 1 }
}

</style>